let allUrlParams = new URLSearchParams(window.location.search);let filter_availability_on = allUrlParams.has('filter_availability') && allUrlParams.get('filter_availability') == 'on';
  /* TECH-2130 Added 'or' condition, when change store, we want to set filter_clearance_on as true to trigger code for switching clearance filter  */   
  let filter_clearance_on = allUrlParams.has('filter_clearance') && allUrlParams.get('filter_clearance') == 'on' || window.location.search.includes("Clearance_Available%20at%20");/*
  NOTE:
    all variables defined 'fs'* are defined in fs-helpers
*/

function handleRemovableTagsWhenTopPageHookIsNotTriggered () {
  document.dispatchEvent(new CustomEvent('updateToggleStateWhenRemoveableTagsClickedButTopPageHookNotTriggered'));
}


function buildInStockZeroCheckbox(availabilityCheckboxElementsArray) {
  /* instead of building the element from scratch, just clone the top hidden element and its children then customize it */
  const unavailableStockText =  'In stock'; /* we used to use In Stock (0) but now the count is a different element so we use In Stock */
  const clonedInStockFilterElement = availabilityCheckboxElementsArray[0].cloneNode(true); 
  clonedInStockFilterElement.classList.remove('coast-hidden');
  clonedInStockFilterElement.style.display = null;
  clonedInStockFilterElement.classList.add('unavailable-stock-facet');
  const clonedInStockFilterTextElement = clonedInStockFilterElement.querySelector('.filters-option-text');/* this is in stock text */
  clonedInStockFilterTextElement.textContent = window.innerWidth < 641 ? `${unavailableStockText} (0)` : unavailableStockText; /* we need to change the textContent based on mobile since it renders differently */
  clonedInStockFilterElement.querySelector('input').setAttribute('aria-label', 'unavailable-stock-facet');
  const clonedInStockFilterTextCountElement = clonedInStockFilterElement.querySelector('.count');/* this is the count (0) */
  clonedInStockFilterTextCountElement.textContent = '(0)';
  const stockDefaultNode = document.createElement('span');
  stockDefaultNode.appendChild(clonedInStockFilterElement); 
  
  return stockDefaultNode;
}

function loadAvailabilityFilter(facets, element) {
  const storeName = GetSelectedStoreName();
  
    const availabilityStoreName =  fsInStockFilterTagPartial + storeName;
    const inStockName = fsAvailabilityFilterCheckboxTextPartialInStockAt;
  
  const inStockTag = fsInStockFilterTagPartial + storeName;
  const inStockCanadaWideName = "In Stock Canada Wide";

  const allHiddenElements = element.querySelectorAll('.coast-hidden');
  const allHiddenElementsArray = Array.from(allHiddenElements);
  for(const hiddenElement of allHiddenElementsArray) {
    hiddenElement.classList.remove('coast-hidden');
    hiddenElement.style.display = null;
  }
  const unavailableStockElements = element.querySelectorAll('.unavailable-stock-facet');
  const unavailableStockElementsArray = Array.from(unavailableStockElements);
  for(const unavailableStockElement of unavailableStockElementsArray) {
    unavailableStockElement.remove();
  }
  const availabilityFilterGroup = element.querySelector(fsAvailabilityFilterId);

  const hasAvailabilityFacet = facets.some(facet => facet.name === fsInStockFilterTitle); 
  /* since we hide the availability filters based on store location, the event is dispatched at the bottom of this function since we check set the unavailabile-stock element */
  let inStockToggleEvent = hasAvailabilityFacet ? 'filters:show-in-stock-toggle' : 'filters:hide-in-stock-toggle';

  hasInStockCanadaWide = facets.some(facet => facet.values.some(tag => tag.name === fsInStockCanadaWideTag)); /* this variable is defined in fs-helpers and used there as well, we just set it here with the facets */
  const hasInStockAtLocation = facets.some(facet => facet.values.some(tag => tag.name === inStockTag)); /* this variable is defined in fs-helpers and used there as well, we just set it here with the facets */

  if(hasInStockCanadaWide === true && hasInStockAtLocation === false) {
    isOnlyInStockCanadaWide = true;
  } else {
    isOnlyInStockCanadaWide = false;
  }
  const hasSaleFacet = facets.some(facet => facet.name === fsOnSaleFilterTitle);
  const onSaleToggleEvent = hasSaleFacet ? 'filters:show-on-sale-toggle' : 'filters:hide-on-sale-toggle';
  document.dispatchEvent(new CustomEvent(onSaleToggleEvent)); /* we use an event to push to fs-toggles so it knows to show/hide the on sale toggle if the filter does not exist*/

  if (availabilityFilterGroup && hasAvailabilityFacet) {
    const availabilityCheckboxElements = availabilityFilterGroup.querySelectorAll('.fs-checkbox');
    const availabilityCheckboxElementsArray = Array.from(availabilityCheckboxElements);
    const filteredAvailabilityCheckboxElements = availabilityCheckboxElementsArray.filter(element => element.querySelector('.filters-option-text').textContent == availabilityStoreName);
    
    for (const checkboxElement of availabilityCheckboxElementsArray) {
      const checkboxTextElement = checkboxElement.querySelector('.filters-option-text');
      const facetValue = checkboxTextElement.textContent.trimEnd();
      const inStockFacetValue = availabilityStoreName.toLowerCase();
      const isFacetInStockCanadaWide = [fsInStockCanadaWideTag.toLowerCase(), inStockCanadaWideName.toLowerCase()].includes(facetValue.toLowerCase());
      const isFacetInStockAtLocation = [inStockFacetValue, inStockName.toLowerCase()].includes(facetValue.toLowerCase());

      
        const storeId = GetSelectedStoreId();
        const inStockOnlineFacetValue = fsInStockOnlineFilterTagPartial + storeId;
        const isFacetInStockOnlineAtStore = [inStockOnlineFacetValue.toLowerCase(), fsAvailabilityFilterCheckboxTextInStockOnlineAtStore.toLowerCase()].includes(facetValue.toLowerCase());
        const shouldHideFacet = isFacetInStockCanadaWide === false && isFacetInStockAtLocation === false && !checkboxElement.classList.contains('unavailable-stock-facet') && isFacetInStockOnlineAtStore === false;
      
      if (isFacetInStockCanadaWide) {
        checkboxTextElement.textContent = inStockCanadaWideName;
      } else if (isFacetInStockAtLocation) {
        checkboxTextElement.textContent = inStockName;
      } else if (isFacetInStockOnlineAtStore) {
        checkboxTextElement.textContent = fsAvailabilityFilterCheckboxTextInStockOnlineAtStore;
      } else if (shouldHideFacet) {
        checkboxElement.classList.add('coast-hidden');
        checkboxElement.style.display = 'none'; /* this line is needed because add hidden class does not work on mobile */
      } 
    }
    const hiddenAvailabilityFilterGroups = availabilityFilterGroup.querySelectorAll('.coast-hidden');
    const hiddenAvailabilityFilterGroupsArray = Array.from(hiddenAvailabilityFilterGroups);

    if (hiddenAvailabilityFilterGroupsArray.length === availabilityCheckboxElementsArray.length) { /* this means all the filters are hidden we need to add the default one */ 
      inStockToggleEvent = 'filters:hide-in-stock-toggle';
      const filterItems = availabilityFilterGroup.querySelector('.category-items');
      const existingUnavailableStock = filterItems.querySelector('.unavailable-stock-facet');
      if(!existingUnavailableStock){
        const stockDefaultNode = buildInStockZeroCheckbox(availabilityCheckboxElementsArray);
        const firstStockFacet = filterItems.querySelector('span > div.fs-checkbox').parentNode;
        filterItems.insertBefore(stockDefaultNode, firstStockFacet);
      }
    }
  }
  document.dispatchEvent(new CustomEvent(inStockToggleEvent)); /* we use an event to push to fs-toggles so it knows to show/hide the stock toggle if the product is unavailable-stock*/
  addToggleEventListeners(element, availabilityStoreName);
}
    
function getFilterCheckboxArray(filtersContainerElement, selector, sameDayPickup = false) {
  const filterGroupElement = filtersContainerElement?.querySelector(selector);
  const filterCheckboxElements = filterGroupElement?.querySelectorAll('.fs-checkbox');
  const filterCheckboxElementsArray = Array.from(filterCheckboxElements);

  
    const filterCheckboxesArray = filterCheckboxElementsArray?.filter(filterCheckboxElement => {
      const filterText = sameDayPickup ? fsAvailabilityFilterCheckboxTextInStockOnlineAtStore.toLowerCase() : fsAvailabilityFilterCheckboxTextPartialEligibleAt.toLowerCase();
      const isNotToggleCheckbox = filterCheckboxElement.querySelector('input').ariaLabel.toLowerCase().includes(filterText);
      return !filterCheckboxElement.classList.contains('coast-hidden') && !isNotToggleCheckbox;
    });    
  
  return filterCheckboxesArray;
}

function addToggleEventListeners(element, availabilityStoreName) {
  document.addEventListener(`toggles:click-in-stock-toggle`, () => {
    const inStockCheckboxesArray = getFilterCheckboxArray(element, fsAvailabilityFilterId);
    for(const filterCheckboxElement of inStockCheckboxesArray) {
      const filterCheckboxInputElement = filterCheckboxElement.querySelector('input');
      setTimeout(() => {
        if(!filterCheckboxElement.classList.contains('fs-selected-checkbox') && filterCheckboxInputElement.checked === false) {
          filterCheckboxElement.click();
        }
      }, 500);
    }
  });
  
  document.addEventListener(`toggles:click-on-sale-toggle`, () => {
    const onSaleCheckboxesArray = getFilterCheckboxArray(element, '#fs_filter_sale');
    onSaleCheckboxesArray[0].click(); /*currently on sale checkboxes is only 1 so we can directly access it from the array*/
  });


  document.addEventListener('toggles:click-same-day-pickup-toggle', (event) => {
    /* We only run this event when the screensize is larger than 820 to avoid conflict with the mobile events in fs-toggles/attachToggleListeners() */
    const sameDayPickupCheckboxesArray = getFilterCheckboxArray(element, fsAvailabilityFilterId, true);
    for(const filterCheckboxElement of sameDayPickupCheckboxesArray) {
      const filterCheckboxInputElement = filterCheckboxElement.querySelector('input');
      setTimeout(() => {
        if(!filterCheckboxElement.classList.contains('fs-selected-checkbox') && filterCheckboxInputElement.checked === false) {
          filterCheckboxElement.click();
        }
      }, 500);
    }
  });
}


function hideOtherClearanceFilters(element) {
  /** Clearance--hide clearance element by default but remove hidden if settings enabled **/
  const isClearanceEnabled = true
  const clearanceFilterGroup = element.querySelector('#fs_filter_clearance');
  if (isClearanceEnabled && clearanceFilterGroup) {
    clearanceFilterGroup.classList.remove('coast-hidden');     
    /** Clearance--hidding all but the region of the selected store **/
    const url = getStoreLocationsJson();
    const store_region = GetSelectedStoreRegion();
    store_region.then((store_region) => {
      if (store_region) {  
        const clearanceRegionName = fsClearanceFilterCheckboxTextPartial + store_region;
        const clearanceCheckboxes = clearanceFilterGroup.querySelectorAll('.fs-checkbox');
        const clearanceCheckboxesArray = Array.from(clearanceCheckboxes);
        const checkboxesToHide = clearanceCheckboxesArray.filter(checkbox => {
          const checkboxTextContentCheck = checkbox.querySelector('.filters-option-text').textContent.toLowerCase();
          const clearanceRegionCheck = clearanceRegionName.toLowerCase();
          return !checkboxTextContentCheck.includes(clearanceRegionCheck);
        });
        if (checkboxesToHide.length ===  clearanceCheckboxesArray.length) {
          /** hide the whole clearance section when there is no checkbox matches with the region to which the selected store location belongs to **/
          clearanceFilterGroup.classList.add('coast-hidden');
        } else {
          /** hide all the other regions except the region to which the selected store location belongs to **/
          checkboxesToHide.forEach( (clearanceCheckBox) => {
            clearanceCheckBox.classList.add('coast-hidden');
            clearanceCheckBox.style.display = 'none';
          });
        }
      }
    });
  }
}

function setAutoFilter(filterGroup, filterCheckboxText, auto_filter_on) {
  const filterCheckboxes = filterGroup.querySelectorAll('.fs-checkbox');
  const filterCheckboxesArray = Array.from(filterCheckboxes);

  if (auto_filter_on) {
  
    const checkboxOfSelectedStoreOrRegion = filterCheckboxesArray.find((filterCheckBox) => {
      const filterCheckBoxTextContentCheck = filterCheckBox.querySelector('.filters-option-text').ariaLabel.toLowerCase();
      const filterCheckboxTextCheck = filterCheckboxText.toLowerCase();
      return filterCheckBoxTextContentCheck === filterCheckboxTextCheck;
    });
  

    if (checkboxOfSelectedStoreOrRegion) {
      const checkboxOfSelectedStoreOrRegionInput = checkboxOfSelectedStoreOrRegion.querySelector('input');
      if (checkboxOfSelectedStoreOrRegionInput && !checkboxOfSelectedStoreOrRegionInput.checked) {
        checkboxOfSelectedStoreOrRegion.click();
      }
    }
  }
}

/* When there is filter_availability or filter_clearance in url, selected store availability checkbox or region clearance checkbox should be auto-selected */
async function setAutoFilters(element) {
  const clearanceFilterGroup = element.querySelector('#fs_filter_clearance');
  const availabilityFilterGroup = element.querySelector(fsAvailabilityFilterId);
  if (availabilityFilterGroup && filter_availability_on) {
    
      const storeId = GetSelectedStoreId();
      const availabilitySelectedStoreCheckboxText = `${fsInStockOnlineFilterTagPartial}${storeId}`;
    
    setAutoFilter(availabilityFilterGroup, availabilitySelectedStoreCheckboxText, filter_availability_on);
    filter_availability_on = false;
  }
  
  if (clearanceFilterGroup && filter_clearance_on) {
    const store_region = await GetSelectedStoreRegion();
    const clearanceSelectedRegionCheckboxText = fsClearanceFilterCheckboxTextPartial + store_region;
    setAutoFilter(clearanceFilterGroup, clearanceSelectedRegionCheckboxText, filter_clearance_on);
    filter_clearance_on = false;
  }
}
